import React from 'react'
import type { SelectionI } from '../../types/constants'
import {
    ProductAdBulkActionModal,
    type ProductAdBulkActionModalProps,
} from './ProductAdBulkActionModal'

export type AddSkusModalProps = Omit<ProductAdBulkActionModalProps, 'identifier'> & {
    selectedValues: SelectionI
}

export const AddSkusModal = (props: AddSkusModalProps) => (
    <ProductAdBulkActionModal {...props} identifier="sku" />
)
